import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "grid grid-cols-1 lg:grid-cols-2 gap-3"
}
const _hoisted_2 = {
  key: 1,
  class: "flex flex-col items-center gap-2 rounded-xl border border-dashed border-gray-200 bg-gray-50 px-4 py-8 text-center",
  "data-testid": "doctor-invites-empty"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", { class: "text-sm text-gray-500" }, "Nenhum vínculo com empresa.", -1)

import { mdiOfficeBuildingOutline } from '@mdi/js'

import SVGIcon from '@/components/SVGIcon.vue'
import type { DoctorDetailCompanyLink } from '@/Network/Types/Responses/CompanyResponses'
import DetailCard from '../atoms/DetailCard.vue'
import CompanyInviteRow from '../atoms/CompanyInviteRow.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'CompanyInvitesPanel',
  props: {
    companies: {}
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(DetailCard, { title: "Vínculos por empresa" }, {
    default: _withCtx(() => [
      (_ctx.companies.length > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.companies, (link) => {
              return (_openBlock(), _createBlock(CompanyInviteRow, {
                key: link.companyDoctorId,
                link: link
              }, null, 8, ["link"]))
            }), 128))
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createVNode(SVGIcon, {
              path: _unref(mdiOfficeBuildingOutline),
              class: "text-2xl text-gray-400"
            }, null, 8, ["path"]),
            _hoisted_3
          ]))
    ]),
    _: 1
  }))
}
}

})